import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business メンバー管理フォルダの index。メンバー管理はサイドバーではフォルダ（遷移なし）だが、
 *  URL 直打ち等で /members に来た場合は既定サブページのエンジニア看板へリダイレクトする
 * @graph-connects none
 */
export const Route = createFileRoute('/members/')({
  beforeLoad: (): never => {
    throw redirect({ to: '/members/engineer-board' }) as unknown as Error;
  },
  component: () => null,
});
